import { render, staticRenderFns } from "./SceneContainer.vue?vue&type=template&id=8713a146&scoped=true&"
import script from "./SceneContainer.vue?vue&type=script&lang=ts&"
export * from "./SceneContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SceneContainer.vue?vue&type=style&index=0&id=8713a146&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8713a146",
  null
  
)

export default component.exports